export const SET_TABLE= 'SET_TABLE'
export const SET_TABLE_SUCCESS= 'SET_TABLE_SUCCESS'
export const SET_TABLE_ERROR= 'SET_TABLE_ERROR'


export const SetTable= (data) => ({
    type: SET_TABLE,
    payload: data
});
